import React from 'react'
import injectSheet from 'react-jss'
import styles from './examples-table.styles'
import { Table, HeadCell } from 'pobble-components/dist/table'
import ExamplesEntry from './examples-entry/examples-entry.container'

const ExamplesTable = ({ classes, examples }) => (
  <Table>
    <thead>
      <tr>
        <HeadCell className={classes.left}>Thumb</HeadCell>
        <HeadCell className={classes.left}>Date</HeadCell>
        <HeadCell className={classes.left}>Owner</HeadCell>
        <HeadCell className={classes.titleCell}>Title</HeadCell>
        <HeadCell className={classes.titleCell}>Age Group</HeadCell>
        {/*<HeadCell className={classes.left}>Student</HeadCell>*/}
        {/*<HeadCell className={classes.center}>Conclusion</HeadCell>*/}
      </tr>
    </thead>
    <tbody>
      {examples.map(example => (
        <ExamplesEntry key={example.id} id={example.id} />
      ))}
    </tbody>
  </Table>
)

export default injectSheet(styles)(ExamplesTable)
